import { useState } from "react";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { splitDate } from "../../../../utils/splitDate";
import { SingleBedIconSvg, CalendarIconSvg, MoonIconSvg, UserIconSvg, InfoIconSvg } from "../../../../assets/svg";
import ModalWrapper from "../../../../components/ModalWrapper/ModalWrapper";
import ViewDetailsModal from "../../../../components/Modals/ViewDetailModal/ViewDetailModal";
import dayjs from "dayjs";

const CustomerQuotationRow = ({item,fetchData}:any) => {
  const [modalViewState, setModalViewState] = useState<boolean>(false);
  const[show,setShow]= useState(false)

  const toggleDetailsModal = () => {
    setShow(prev => !prev)
  }

  return (
    <div key={item?.quotation_id} className="min-h-[151px] my-3 border rounded bg-light">
      <Row
        className="bg-[#F9FFF2] border-bottom rounded-top min-h-[34px] m-0 justify-content-between align-items-center "
        style={{ fontSize: "16px", fontWeight: "700" }}
      >
        <Col>
          <p className="m-0">{item?.it_route}</p>
        </Col>
        <Col className="d-flex justify-content-end align-items-center">
          <p className={`px-2 m-0 text-${item?.q_status === "ACTIVE" ? 'success' : item?.q_status === "SHARED" || item?.q_status === "PARTIAL_PAID" ? 'warning' : 'danger'}`}>STATUS : {item?.q_status === "SHARED" ? "Quotation Shared" : item?.q_status?.replace('_', ' ')}</p>
        </Col>
      </Row>
      <Row className="justify-content-between m-0 mt-4 text-[#7A7A7A] text-nowrap" style={{ fontSize: "17px", fontWeight: "500" }}>
        <Col xs={5} className="d-flex align-items-center">
          <CalendarIconSvg width={18} height={18} fill="#7a7a7a"/>
          <p className="mx-1 my-auto"> {dayjs(splitDate(item?.it_start_time)).format("DD MMM YYYY")} - {dayjs(splitDate(item?.it_end_time)).format("DD MMM YYYY")}</p>
        </Col>
        <Col className="d-flex align-items-center">
          <MoonIconSvg fill="#7a7a7a"/>
          <p className="mx-1 my-auto">{item?.it_night_count} Nights</p>
        </Col>
        <Col className="d-flex align-items-center">
          <UserIconSvg fill="#7a7a7a"/>
          <p className="mx-1 my-auto">{(Number(item?.q_adults) || 0) + (Number(item?.q_children) || 0) + (Number(item?.q_infants) || 0)} Guests</p>
          <OverlayTrigger delay={{ hide: 0, show: 50 }} placement="bottom"
            overlay={
              <Tooltip>
                  {`Adult: ${item?.q_adults || 0}`}
                  <br />
                  {`Children: ${item?.q_children || 0}`}
                  <br />
                  {`Infant: ${item?.q_infants || 0}`}
              </Tooltip>
            }>
            <span className="cursor-pointer">
              <InfoIconSvg fill="#D0566E" />
            </span>
          </OverlayTrigger>
        </Col>
        <Col className="d-flex align-items-center">
          <SingleBedIconSvg fill="#7a7a7a"/>
          <p className="mx-1 my-auto">{item?.room_count} {item?.room_count > 1 ? 'Cabins' : 'Cabin'}</p>
          <OverlayTrigger delay={{ hide: 0, show: 50 }} placement="bottom"
            overlay={
              <Tooltip>
                  {item?.cabin_categories && item?.cabin_categories.map((cabin: any) => <>{cabin}<br/></>)}
              </Tooltip>
            }>
            <span className="cursor-pointer">
              <InfoIconSvg fill="#D0566E" />
            </span>
          </OverlayTrigger>
        </Col>
        <Col>
          <p className="px-2 m-0 text-[#92278F]">{item?.quotation_number}</p>
        </Col>
      </Row>
      <Row
        className="d-flex text-[#3A3A3A] mx-0 mt-3 justify-content-between"
        style={{ fontSize: "17px", lineHeight: "18.23px", fontWeight: "500" }}
      >
        <Col>
          <p className="m-0 text-capitalize">{item?.it_ship_name.toLowerCase()}</p>
        </Col>
        <Col>
          <p className="m-0 text-nowrap">Enquiry Date & Time : <span style={{fontWeight:400,fontSize:"16px"}}>{dayjs(item?.q_created_at).format('DD MMM YYYY | h:mma')}</span></p>
        </Col>
        <Col>
          <p className="m-0">Agent Name & ID : {item?.st_first_name}</p>
        </Col>
        <Col className="d-flex align-items-center justify-content-end mx-2">
          <button
            className="border p-1 rounded bg-[#EEEEEE] text-nowrap my-auto text-[#3A3A3A]"
            style={{ fontSize: "14px", fontWeight: "400" }} onClick={toggleDetailsModal}
          >
            View Details
          </button>
        </Col>
      </Row>
       <ModalWrapper show={show} handleClose={()=>{
        fetchData() 
        setShow(false)}}
         clx='view-detail-modal-wrapper max-h-[90vh]'
         >
       <ViewDetailsModal quotationDetail={item?.quotation_id} />
     </ModalWrapper>
    </div>
  );
};
export default CustomerQuotationRow;
